import { useNavigate } from '@tanstack/react-router';
import { Card } from '@/primer/components';
import { Button } from '@/primer/components';
import Typography from '@/primer/components/Typography/Typography';
import { SocialLoginButtons } from '@/components/ui/SocialLoginButtons';
import { PageLayout } from '@/components/layout';

/**
 * Landing — the unauthenticated entry screen.
 *
 * Presents the primary auth entry points:
 * - "Continue with email" navigates to the Login screen
 * - Social login buttons (Facebook, Apple, Google) trigger OAuth
 *   redirects directly via the Cognito Hosted UI
 *
 * The Influenster for Creators logo is rendered by PreAuthLayout — this
 * component owns only the card content.
 */
export function Landing() {
  const navigate = useNavigate();

  return (
    <PageLayout className="py-8" gridProps={{ className: 'px-5' }}>
      <Card translucent shadow="second">
        <div className="p-6 space-y-3">
          {/* Continue with email — primary CTA */}
          <Button
            variant="primary"
            fullWidth
            onClick={() => void navigate({ to: '/login' })}
            data-testid="continue-with-email-button"
          >
            Continue with email
          </Button>

          {/* Divider */}
          <Typography variant="body" size="medium" color="bodylighter" align="center" as="p">
            Or
          </Typography>

          {/* Social login buttons */}
          <SocialLoginButtons />
        </div>
      </Card>
    </PageLayout>
  );
}

export default Landing;
